import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { TopbarContainer } from '..';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Page,
  Modal,
  ZoomComponent,
} from '../../components';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import { manageDisableScrolling } from '../../ducks/UI.duck';

import css from './ZoomPage.css';

export const ZoomPageComponent = props => {
  const { currentUser, intl, scrollingDisabled } = props;

  const user = ensureCurrentUser(currentUser);

  return (
    <Page
      title="Zoom"
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'ContactStaticPage',
        description: 'Zoom',
        name: 'Zoom page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>Zoom</h1>

          <div className={css.contentWrapper}>
            <div className={css.contentSide}>
              <p> </p>
            </div>

            <div className={css.contentMain}>
              {user.id !== null ? <ZoomComponent user={user} /> : null}
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

ZoomPageComponent.defaultProps = {
  currentUser: null,
};

const { bool, func, object, oneOf, shape } = PropTypes;

ZoomPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
  scrollingDisabled: bool.isRequired,
  onManageDisableScrolling: func.isRequired,
  location: shape({ state: object }).isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const ZoomPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ZoomPageComponent);

export default ZoomPage;
